var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 4.02917V6.98715C8.88889 8.0375 8.0375 8.88889 6.98715 8.88889H3.0125C1.96215 8.88889 1.11076 8.0375 1.11076 6.98715V4.02917C1.11076 3.875 0.985764 3.75 0.831597 3.75H0.279167C0.125 3.75 0 3.875 0 4.02917V7.19688C0 8.74514 1.25486 10 2.80313 10H7.19688C8.74514 10 10 8.74514 10 7.19688V4.02917C10 3.875 9.875 3.75 9.72083 3.75H9.1684C9.01424 3.75 8.88924 3.875 8.88924 4.02917H8.88889Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90934 3.76828L5.67775 4.99988C5.63261 5.04502 5.55552 5.01307 5.55552 4.94918V0.276267C5.55552 0.123489 5.43156 -0.00012207 5.27913 -0.00012207H4.72115C4.56837 -0.00012207 4.44476 0.123836 4.44476 0.276267V4.94918C4.44476 5.01307 4.36768 5.04467 4.32254 4.99988L3.09094 3.76828C2.98156 3.65891 2.80448 3.65891 2.69511 3.76828L2.30518 4.15821C2.1958 4.26759 2.1958 4.44467 2.30518 4.55404L4.80552 7.05439C4.91281 7.16168 5.08712 7.16168 5.19441 7.05439L7.69476 4.55404C7.80413 4.44467 7.80413 4.26759 7.69476 4.15821L7.30483 3.76828C7.19545 3.65891 7.01837 3.65891 6.909 3.76828H6.90934Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.6840c471906ea31601f980ab319238b2.svg";
export { ForwardRef as ReactComponent };